import { useEffect, useRef } from 'react';

import { AgButton } from 'src/components/ui';
import { AttachedLabel, useLabelAttachmentsStore } from './labelAttachments.store';
import ShowMoreLabelsDropdown from './ShowMoreLabelsDropdown';

export default function ShowMoreLabels({ hiddenLabels, canEdit }: { hiddenLabels: AttachedLabel[]; canEdit: boolean }) {
  const open = useLabelAttachmentsStore((state) => state.openShowMoreLabelsDropdown);
  const close = useLabelAttachmentsStore((state) => state.closeShowMoreLabelsDropdown);
  const anchorEl = useRef(null);

  useEffect(() => {
    if (hiddenLabels.length === 0) {
      close();
    }
  }, [hiddenLabels, close]);

  if (hiddenLabels.length === 0) return null;

  const labelString = hiddenLabels?.length === 1 ? 'label' : 'labels';

  return (
    <>
      <AgButton
        variant="ghost"
        size="xs"
        shape="rounded"
        className="text-brand-6 font-semibold"
        onPress={open}
        ref={anchorEl}
      >
        +{hiddenLabels?.length} {labelString}
      </AgButton>
      <ShowMoreLabelsDropdown anchorEl={anchorEl} hiddenLabels={hiddenLabels} canEdit={canEdit} />
    </>
  );
}
